import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const LayoutArquivosDialog = ({ open, handleClose }) => {
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Layout padrão de arquivos para importação</DialogTitle>
            <DialogContent dividers>
                {/* Paper para Conciliação histórico contábil */}
                <Paper style={{ padding: '16px', marginBottom: '16px' }}>
                    <Typography variant="h6" gutterBottom>
                        Tipo de Conciliação: Conciliação histórico contábil
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Histórico</TableCell>
                                    <TableCell>Lote</TableCell>
                                    <TableCell>Débitos</TableCell>
                                    <TableCell>Créditos</TableCell>
                                    <TableCell>Razão Social</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Preencha esta seção com dados reais ou exemplos */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                {/* Paper para Conciliação bancária */}
                <Paper style={{ padding: '16px', marginBottom: '16px' }}>
                    <Typography variant="h6" gutterBottom>
                        Tipo de Conciliação: Conciliação bancária
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        Arquivo sistema:
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Histórico</TableCell>
                                    <TableCell>Lote</TableCell>
                                    <TableCell>Débitos</TableCell>
                                    <TableCell>Créditos</TableCell>
                                    <TableCell>Saldo</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Preencha esta seção com dados reais ou exemplos */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Typography variant="subtitle1" gutterBottom marginTop={2}>
                        Arquivo Banco:
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Histórico</TableCell>
                                    <TableCell>Lote</TableCell>
                                    <TableCell>Débitos</TableCell>
                                    <TableCell>Créditos</TableCell>
                                    <TableCell>Saldo</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Preencha esta seção com dados reais ou exemplos */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                {/* Paper para Conciliação arquivo auxiliar */}
                <Paper style={{ padding: '16px', marginBottom: '16px' }}>
                    <Typography variant="h6" gutterBottom>
                        Tipo de Conciliação: Conciliação arquivo auxiliar
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Histórico</TableCell>
                                    <TableCell>Lote</TableCell>
                                    <TableCell>Débitos</TableCell>
                                    <TableCell>Créditos</TableCell>
                                    <TableCell>Razão Social</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Preencha esta seção com dados reais ou exemplos */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </DialogContent>
            <DialogActions>
                <IconButton aria-label="Fechar" onClick={handleClose} style={{ position: 'absolute', top: 0, right: 0 }}>
                    <CloseIcon />
                </IconButton>
            </DialogActions>
        </Dialog>
    );
};

export default LayoutArquivosDialog;
